import { Controller } from "@hotwired/stimulus";
import { enter, leave } from "el-transition";

export default class extends Controller {
    static targets = ["menu", "button"]

    initialize() {
        document.addEventListener("click", (event) => {
            if (event.target === this.buttonTarget || this.buttonTarget.contains(event.target)) {
                return;
            }

            if (!this.menuTarget.classList.contains("hidden")) {
                leave(this.menuTarget).then(() => {
                    this.menuTarget.classList.add("hidden");
                });
            }
        });
    }

    toggle(event) {
        if (this.menuTarget.classList.contains("hidden")) {
            this.menuTarget.classList.remove("hidden");
            enter(this.menuTarget);
        } else {
            leave(this.menuTarget).then(() => {
                this.menuTarget.classList.add("hidden");
            });
        }
        event.preventDefault();
    }
}